import React from 'react';
import styled from '@emotion/styled';

const DateInput = styled('input')`
  ::-webkit-datetime-edit {
    padding: 13px 12px;
  }

  ::-webkit-datetime-edit-text {
    padding: 12px 2px;
  }

  ::-webkit-inner-spin-button {
    display: none;
  }

  ::-webkit-calendar-picker-indicator {
    padding: 12px 12px;
    cursor: pointer;
  }

  &:focus-visible {
    outline-color: unset;
  }

  &:hover {
    border-color: ${(p) => p.theme.colors.primary['600']};
  }

  cursor: text;
  background-color: transparent;
  border: 1px solid ${(p) => p.theme.colors.muted['400']};
  border-radius: 4px;
  font-size: 18px;
  width: 100%;
`;

export const DatePicker = ({ value, onChange }) => {
  return (
    <DateInput
      onChange={(e) => onChange(e.target.value)}
      type={'datetime-local'}
      value={value}
    />
  );
};
